// extracted by mini-css-extract-plugin
export var alternate = "_g-j";
export var black = "_g-6";
export var blue = "_g-f";
export var blueLight = "_g-e";
export var brand = "_g-8";
export var darkMode = "_g-b";
export var error = "_g-a";
export var gray = "_g-5";
export var grayBlue = "_g-d";
export var iconWrapper = "_g-3";
export var inactive = "_g-7";
export var indigo = "_g-g";
export var orange = "_g-i";
export var pink = "_g-h";
export var primary = "_g-0";
export var purple = "_g-9";
export var success = "_g-4";
export var warning = "_g-c";
export var white = "_g-1";
export var whiteSuccess = "_g-2";